import { Outlet } from 'react-router-dom'

import LeftArrow from '@/assets/icons/left-arrow.svg?react'

export function PaymentCallbackLayout() {
  const closeWindow = () => {
    window.opener?.postMessage({ success: true }, '*')
    window.close()
  }

  return (
    <div className="h-full flex flex-col">
      <header className="px-8 py-4 border-b-[2px] border-solid border-gray100">
        <div className="w-12 h-12 icon-btn" onClick={closeWindow}>
          <LeftArrow />
        </div>
      </header>
      <main className="flex-1 bg-[url(@/assets/images/bg-page.svg)] bg-cover bg-no-repeat bg-[center_top_118px]">
        <Outlet />
      </main>
    </div>
  )
}
